export const IconTypes = [
  'arrow-down',
  'arrow-left',
  'arrow-right',
  'arrow-up',
  'bank',
  'bulb',
  'building',
  'calendar',
  'camera',
  'caret-down',
  'caret-left',
  'caret-right',
  'caret-up',
  'change',
  'check',
  'check-circle',
  'device-desktop',
  'device-mobile',
  'document',
  'dots-horizontal',
  'download',
  'draw',
  'driving-license',
  'edit',
  'email',
  'emoji-smile',
  'euro',
  'external-link',
  'fullscreen',
  'globe',
  'home',
  'id',
  'identity-card',
  'info',
  'letter',
  'lightbulb',
  'light-mode',
  'micropayment',
  'mismatch',
  'monitor',
  'passkey',
  'passport',
  'plus',
  'printer',
  'refresh',
  'residence-permit',
  'roles-user',
  'search',
  'selected-document',
  'society-statement',
  'trash',
  'questionmark-circle',
  'upload',
  'upload-file',
  'user',
  'utility-bill',
  'warning',
  'x-mark',
  'x-mark-circle',
  'zoom-in',
  'zoom-out',
] as const

export type IconType = (typeof IconTypes)[number]
